import { useQuery } from '@tanstack/react-query';
import { DataCard, SkeletonCard, QueryError } from '../../../../components/ui';
import { api } from '../../../../lib/api';

export function ConcentrationWidget() {
  const concentration = useQuery<{ topShare: number | null; customers: { customerName: string }[] | null }>({
    queryKey: ['concentration-risk'],
    queryFn: async () => {
      return api('/v1/concentration-risk');
    },
    staleTime: 10 * 60_000,
    retry: 0,
  });

  const c = concentration.data;

  return (
    <DataCard
      title="Concentration Risk"
      subtitle="What % of revenue lives with your top client"
      accent={(c?.topShare ?? 0) >= 30 ? 'danger' : (c?.topShare ?? 0) >= 20 ? 'warn' : 'success'}
    >
      {concentration.isLoading ? <SkeletonCard /> : concentration.isError ? <QueryError error={concentration.error} onRetry={() => concentration.refetch()} compact /> : !c || c.topShare == null ? (
        <p className="text-2xs text-ink-dim italic">Connect Stripe or QuickBooks to compute concentration.</p>
      ) : (
        <div className="space-y-2">
          <div className="flex items-baseline gap-2">
            <span className="font-mono text-2xl font-semibold tabular-nums text-ink">{c.topShare.toFixed(0)}%</span>
            <span className="text-2xs text-ink-dim">top client</span>
          </div>
          {c.customers?.[0]?.customerName && <p className="text-2xs text-ink-muted truncate">{c.customers[0].customerName}</p>}
          <p className="text-2xs text-ink-dim">{(c.topShare ?? 0) >= 30 ? 'High dependency — diversify pipeline.' : (c.topShare ?? 0) >= 20 ? 'Watch — common for boutique firms.' : 'Healthy diversification.'}</p>
        </div>
      )}
    </DataCard>
  );
}
